import { render } from "./PatientProfile.vue?vue&type=template&id=2fae70ce&scoped=true"
import script from "./PatientProfile.vue?vue&type=script&lang=js"
export * from "./PatientProfile.vue?vue&type=script&lang=js"

import "./PatientProfile.vue?vue&type=style&index=0&id=2fae70ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fae70ce"]])

export default __exports__